export default __webpack_public_path__ + "static/img-btc12-baaeafba0562d8b57da49334002443b7.png";